import React from 'react';
import {
  SETUP_DEFAULT_STATUSES,
  StoreSetupField,
  StoreSetupSearch,
  StoreSetupStatus
} from '../../types/storeSetup.types';
import { SetupBeat } from './setupDraft';
import { setupOn } from './setupPreviewModel';

const ROWS = [
  { client: 'Amina B.', phone: '06 12 00 01', amount: '240' },
  { client: 'Youssef K.', phone: '06 18 44 20', amount: '90' },
  { client: 'Sara M.', phone: '07 01 55 12', amount: '410' }
];

type Props = {
  statuses: StoreSetupStatus[];
  searches: StoreSetupSearch[];
  fields: StoreSetupField[];
  beat: SetupBeat | null;
};

function sample(type: string, index: number): string {
  if (type === 'phone') return '06 00 00 00';
  if (type === 'number' || type === 'float') return String(index + 1);
  if (type === 'date') return '12/05';
  if (type === 'email') return 'a@mail.co';
  return '—';
}

const SetupOrders: React.FC<Props> = ({ statuses, searches, fields, beat }) => {
  const list = statuses.length
    ? statuses
    : SETUP_DEFAULT_STATUSES.map((name, index) => ({
      id: `default-${index}`,
      name,
      key: name,
      tone: 'wait' as const,
      system: true
    }));
  const ghost = statuses.length === 0;
  const focusSearch = Boolean(beat?.itemId && searches.some((item) => item.id === beat.itemId));

  return (
    <div className="setup-orders">
      <div className="setup-orders__filters" aria-label="Recherches">
        {searches.some((item) => item.name === 'Toutes') ? null : (
          <span className={focusSearch ? undefined : 'is-current'}>Toutes</span>
        )}
        {searches.map((item) => (
          <span
            key={item.id}
            data-setup-id={item.dashboard ? undefined : item.id}
            className={[
              item.name === 'Toutes' && !focusSearch ? 'is-current' : '',
              setupOn(item.id, beat).trim()
            ].filter(Boolean).join(' ') || undefined}
          >
            {item.name}
          </span>
        ))}
      </div>

      <div className="setup-orders__scroll">
        <table>
          <thead>
            <tr>
              <th>Client</th>
              <th>Téléphone</th>
              {fields.map((field) => (
                <th
                  key={field.id}
                  data-setup-id={field.id}
                  className={setupOn(field.id, beat).trim() || undefined}
                >
                  {field.name}
                </th>
              ))}
              <th>Montant</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row, index) => {
              const status = list[index % list.length];
              return (
                <tr key={row.client}>
                  <td>{row.client}</td>
                  <td>{row.phone}</td>
                  {fields.map((field) => (
                    <td key={field.id}>{sample(field.type, index)}</td>
                  ))}
                  <td>{row.amount}</td>
                  <td>
                    {index === 0 ? (
                      <div className={`setup-status${ghost ? ' is-ghost' : ''}`}>
                        <span className={`setup-pill setup-pill--${status.tone}`}>{status.name}</span>
                        <ul aria-label="Statuts">
                          {list.map((item) => (
                            <li
                              key={item.id}
                              data-setup-id={ghost ? undefined : item.id}
                              className={`${setupOn(item.id, beat)}${item.id === status.id ? ' is-current' : ''}`}
                            >
                              <i className={`setup-pill setup-pill--${item.tone}`} />
                              {item.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <span className={`setup-pill setup-pill--${status.tone}`}>{status.name}</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SetupOrders;
